import StatusMessage from "./statusMessage";

export default class Status {
  messages: StatusMessage[];

  constructor() {
    this.messages = [];
  }

  static fromJSON(json: Record<string, any>): Status {
    const status = new Status();
    status.messages = json.messages.map((x: Record<string, string>) => {
      return StatusMessage.fromJSON(x);
    });

    return status;
  }
}
